import { useTheme } from 'styled-components'

import { Loading } from '@reveni-io/reveni-ui'

import ChartDisplayToggle from '@/metrics/components/ChartDisplayToggle/ChartDisplayToggle'
import CustomLegend from '@/metrics/components/CustomLegend/CustomLegend'
import OpenChartInModal from '@/metrics/components/OpenChartInModal/OpenChartInModal'
import { getRatioBarsChartLegendItems } from '@/metrics/components/RatioBarsChart/helpers'
import RatioBarsChart from '@/metrics/components/RatioBarsChart/RatioBarsChart'

import { getReturnSalesChartSeries } from './helpers'
import * as Styles from './styles'

const ReturnSalesChart = ({
  data,
  metrics,
  timeRangeSelected,
  fullWidth,
  timeDisplay,
  onChangeTimeDisplay,
  showOpenInModal = false,
  modalTitle,
  loading,
}) => {
  const theme = useTheme()
  const series = getReturnSalesChartSeries(theme, metrics)

  return (
    <Styles.ChartContainer>
      <Styles.ChartHeader>
        <CustomLegend legendItems={getRatioBarsChartLegendItems(series)} />
        <Styles.ActionsContainer>
          <ChartDisplayToggle value={timeDisplay} onChange={onChangeTimeDisplay} />
          {showOpenInModal && (
            <OpenChartInModal
              show={data?.length > 0}
              modalTitle={modalTitle}
              chart={
                <ReturnSalesChart
                  data={data}
                  metrics={metrics}
                  loading={loading}
                  timeRangeSelected={timeRangeSelected}
                  fullWidth
                  timeDisplay={timeDisplay}
                  onChangeTimeDisplay={onChangeTimeDisplay}
                />
              }
            />
          )}
        </Styles.ActionsContainer>
      </Styles.ChartHeader>
      <Loading show={loading} height="350px">
        <RatioBarsChart data={data} series={series} timeRangeSelected={timeRangeSelected} fullWidth={fullWidth} />
      </Loading>
    </Styles.ChartContainer>
  )
}

export default ReturnSalesChart
